import SettingsTableButton from "./SettingsTableButton";

export default SettingsTableButton;